/**
 * What agent-written HTML can't do in a view's `custom` component: it runs in a sandbox with no network, storage, or
 * links out, and only reads its props. Said as the agent should hear it, so it can fix the code before anyone sees it.
 */
const SANDBOX_CHECKS: [RegExp, string][] = [
  [
    /\b(?:src|href)\s*=\s*["']?\s*(?:https?:)?\/\//i,
    "It points at another site (a src or href with a URL): the sandbox has no network and opens no links, so that won't load. Inline it, or draw it as SVG.",
  ],
  [
    /@import\b|url\(\s*["']?\s*(?:https?:)?\/\//i,
    'Its CSS loads from another site (@import or url() with a URL): the sandbox has no network.',
  ],
  [
    /\bfetch\s*\(|\bXMLHttpRequest\b|\bWebSocket\b|\bEventSource\b/,
    'It uses the network (fetch, XMLHttpRequest, WebSocket): it can only read window.softmax.props.',
  ],
  [
    /\b(?:localStorage|sessionStorage|indexedDB)\b|document\.cookie/,
    "It uses storage (localStorage, sessionStorage, indexedDB, or cookies), which the sandbox doesn't have: keep state in memory.",
  ],
]

export function sandboxWarnings(html: string): string[] {
  return SANDBOX_CHECKS.filter(([pattern]) => pattern.test(html)).map(([, warning]) => warning)
}
